import * as React from "react"
import "./downloadBanner.scss";
import DocumentThumb from "~/components/atoms/documentThumb";
import IconDocument from "~/assets/icon/icon_document.svg";
import { StaticImage } from "gatsby-plugin-image"

export default () => {

    const downloadLink = "/download";
    return (
        <>
            <div className="downloadBanner common_float_sm">
                <input type="checkbox" id="downloadBanner_checkbox" className="downloadBanner__checkbox"></input>
                <label htmlFor="downloadBanner_checkbox" className="downloadBanner__label">
                    <div className="downloadBanner__icon">
                        <IconDocument />
                    </div>

                    <div className="downloadBanner__text" onClick={() => gtag('event', 'click', {'event_category': 'cv_button','event_label': 'downloadButton_on_hoverBanner1'})}>資料ダウンロードはこちら</div>
                </label>
                <div className="downloadBanner__content">
                    <label htmlFor="downloadBanner_checkbox" className="downloadBanner__closeButton">×</label>
                    <a className="downloadBanner__link" href={downloadLink} onClick={() => gtag('event', 'click', {'event_category': 'cv_button','event_label': 'downloadButton_on_hoverBanner2'})}>
                        <div className="downloadBanner__documentTitle">Sally127の事業紹介資料</div>
                        <div className="downloadBanner__thumbnail">

                        <StaticImage
                            className="documentThumb__image"
                            src="../../images/common/document1_thumb.jpg"
                            alt="事業紹介資料 1.当社スマホ試着概要と実績 2.アパレルECサイトの現状〜課題構造とその解決策〜レポート"
                            width={300}
                        />
                        </div>
                        <div className="downloadBanner__linkText">ダウンロード（無料）</div>
                    </a>
                </div>
            </div>
        </>
    )
};
